import { render, staticRenderFns } from "./auction-research.vue?vue&type=template&id=7896459c&scoped=true"
import script from "./auction-research.vue?vue&type=script&lang=js"
export * from "./auction-research.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7896459c",
  null
  
)

export default component.exports